import { useContext } from 'react';
import useSWR from 'swr';

import PageContext from '@contexts/PageContext';
import API from '@utils/api';
import { useRouter } from 'next/router';
import { ArticlePreview } from '@containers';
import { Container, Button } from '@components';
import { checkEnabled, checkValue } from '@components/OptionalFeature';
import styles from './ProductArticles.module.scss';

const ProductArticles = ({ data: sectionData, id, productType, componentIsAvailable, showTitle, componentTitle }) => {
  const pageData = useContext(PageContext);
  const router = useRouter();
  const { locale } = router;
  let posts;
  let buttonLink = sectionData?.DisplayOptions?.ButtonLinkURL?.OptionInformation;

  //The section title on the page
  const sectionTitle = checkValue(sectionData?.DisplayOptions, 'ComponentHeaderTitleText', locale);

  //The section title on the page
  const buttonText = checkValue(sectionData?.DisplayOptions, 'ButtonText', locale);

  //Related Article Category
  const relatedArticleCategory = sectionData?.DisplayOptions?.find(
    (x) => x.DisplayOptionKey == 'Category'
  )?.OptionInformation;

    //check LinkOut
  const LinkOutEnabled = checkEnabled(sectionData?.DisplayOptions,'LinkOut');

 //show image
 const imageEnabled = checkEnabled(sectionData?.DisplayOptions, 'BackgroundHero');


  if (pageData.RelatedPosts) {
    posts = pageData.RelatedPosts.map(({ p: post }) => post)?.filter((item) =>
      item?.PostTags.map((x) => x?.PostCategoriesTag)
        .map((y) => y.Value)
        .find((m) => m == relatedArticleCategory)
    );
  }

  if (buttonLink?.includes('api/')) {
    const { data: buttonLinkPostData } = useSWR([buttonLink.toLowerCase()], (url) => API.post(url));
    buttonLink = `/${buttonLinkPostData?.Path}`;
  }

  return componentIsAvailable ? (
    <section className={styles.Section} id={id}>
      <Container className={styles.Container}>
        {showTitle && <h2 className={styles.Title}>{sectionTitle}</h2>}
        <div className={styles.List}>
          {posts.slice(0, 4).map((post) => (
            <ArticlePreview key={post.Id} data={post} LinkOutEnabled={LinkOutEnabled} imageEnabled={imageEnabled} />
          ))}
        </div>
        {buttonLink ? (
          <Button outlined {...(buttonLink && { href: buttonLink })} animated>
            {buttonText || 'View All Articles'}
          </Button>
        ) : (
          <Button outlined {...{ href: '/articles' }} animated>
            {buttonText || 'View All Articles'}
          </Button>
        )}
      </Container>
    </section>
  ) : null;
};

export default ProductArticles;
